<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>老师跟踪记录列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6">
          <Form-item label="外管：">
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.adminName"></Input>
          </Form-item>
          </Col>
          <Col :span="6">
          <Form-item label="类型：">
            <Select v-model.number="queryParam.trackType" placeholder="全部" @on-change="search" clearable>
              <Option v-for="item in $constant.tchTrackRecordType"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :span="6">
          <Form-item label="处理人：">
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.modifierName"></Input>
          </Form-item>
          </Col>
          <Col :span="6">
          <Form-item label="老师ID：">
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.tchId"></Input>
          </Form-item>
          </Col>
          <Col :span="6">
          <Form-item label="老师名称：">
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.tchName"></Input>
          </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师手机号：">
              <Input placeholder="支持模糊搜索" name="userNickname"
                     v-model="queryParam.mobile"></Input>
            </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="添加时间：">
            <Row>
              <Col :span="11">
                <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                           @on-change="startTimeDateChange"
                           v-model="queryParam.startTimeDate" style="width: 100%;"></Date-picker>
              </Col>
              <Col :span="1" style="text-align: center">-</Col>
              <Col :span="11">
                <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                           @on-change="endTimeDateChange"
                           v-model="queryParam.endTimeDate" style="width: 100%;"></Date-picker>
              </Col>
            </Row>
          </Form-item>
          </Col>
          <Col :span="2">
              <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                      @click="search" >搜索
              </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/tchTrack/recordList"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId" :successCallback="searchWithPage"></tch-info-modal>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
  </div>

</template>
<script>
  import TchInfoModal from './modal/TchInfoModal.vue'
  import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
  import ShowImageCarousel from '../order/ShowImageCarousel.vue'
  import { renderTrackContentAttach } from '@/utils/trackContentAttach'
import Row from 'iview/src/components/grid/row';
  export default {
    components: {
      TchInfoModal, ShowImageCarousel
    },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        rankScoreSeq: 0,
        exportLoading: false,
        showImgModal: false,
        tchId: null,
        showTchInfoModal: false,
        showImgList: [],
        reload: 0,
        editUser: false,
        uid: null,
        queryParam: {
          uid: '',
          mobile: '',
          userNickname: '',
          adminNickname: '',
          adminMobile: '',
          startTimeDate: '',
          endTimeDate: '',
          startTime: '',
          endTime: '',
          status: null,
          type: '',
          tchId: null,
          subType: null,
          auditorName: ''
        },
        title: [
          {
            title: '老师ID/姓名',
            // width: 150,
            width: 180,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + ' ' + row.tchName,
                score: row.monthRankScore,
                onClick: () => this.openTchInfoModal(row.tchId)
              })
            }
          },
          {
            title: '添加时间',
            align: 'center',
            width: 170,
            key: 'gmtCreate',
          },
          {
            title: '类型',
            align: 'center',
            key: 'trackType',
            // width: 110,
            render: (h, params) => {
              let type = params.row.trackType
              let typeEnum = $constant.getEnum($constant.tchTrackRecordType, type)
              return h('div', typeEnum && typeEnum.text)
            }
          },
          {
            title: '内容',
            align: 'center',
            width: 250,
            render: (h, params) => {
              return renderTrackContentAttach(h, params.row.content, (urls, index) => this.viewFile(urls, index))
            }
          },
          {
            title: '外管',
            align: 'center',
            // width: 120,
            key: 'adminName'
          },
          {
            title: '图片',
            align: 'center',
            // width: 110,
            render: (h, params) => {
              let row = params.row
              if (row.picUrl) {
                return h('a', {on: {click: () => this.viewPic(row)}}, '查看图片')
              } else {
                return h('span', '')
              }
            }
          },
          {
            title: '处理人',
            align: 'center',
            // width: 170,
            key: 'modifierName'
          },
          {
            title: '操作',
            // width: 120,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('a', { on: { click: () => { this.ondelete(params.row) } } }, '删除'),
              ])
            }
          }
        ]
      }
    },
    mounted: function () {
      let self = this
      let query = self.$route.query
      if (query.startTime) {
        this.queryParam.startTimeDate = parseInt(query.startTime) * 1000
      }
      if (query.endTime) {
        this.queryParam.endTimeDate = parseInt(query.endTime) * 1000
      }
    },
    created: function () {
    },
    methods: {
      viewPic (row) {
        this.showImgList = row.urls
        this.showImgModal = true
      },
      viewFile (urls, index) {
        this.showImgList = urls
        this.showImgModal = true
      },
      closeImgModal () {
        this.showImgList = []
        this.showImgModal = false
      },
      closeModal (val) {
        this.uid = null
        this.editUser = val
      },
      openInfoModal (val) {
        this.uid = val
        this.editUser = true
      },
      searchWithPage () {
        this.reload = new Date().getTime()
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },

      startTimeDateChange (value) {
        this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      ondelete (row) {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: '是否 <b>删除</b> 此记录？',
          width: 300,
          okText: '确定删除',
          loading: true,
          onOk: () => {
            self.$http.post('/tchTrack/delete', {id: row.id}).then(function (res) {
              self.search()
              self.$Message.success('提交成功!')
              self.$Modal.remove()
            })
          }
        })
      },
      openTchInfoModal (val) {
        this.tchId = val
        this.showTchInfoModal = true
      },
    }
  }

</script>



// WEBPACK FOOTER //
// TchTrackList.vue?2a6172f4